import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ImagesModule } from '@shared/components/images/images.module';
import { ModalModule } from '@shared/components/modal/modal.module';
import { MostUsedModule } from '@shared/components/most-used/most-used.module';
import { ResetPasswordModule } from '@shared/components/users/reset-password/reset-password.module';
import { UserEditComponent } from './user-edit.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmationModule } from '@shared/components/confirmation/confirmation.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { PhoneInputModule } from '@shared/components/phone-input/phone-input.module';
import { SharedPipesModule } from '@shared/pipes/shared-pipes/shared-pipes.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [UserEditComponent],
  exports: [UserEditComponent],
  imports: [
    CommonModule,
    ModalModule,
    ImagesModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    FormsModule,
    MatButtonModule,
    MostUsedModule,
    MatIconModule,
    ConfirmationModule,
    ClipboardModule,
    PhoneInputModule,
    SharedPipesModule,
    MatFormFieldModule,
    MatInputModule,
    ResetPasswordModule,
  ],
})
export class UserEditModule {}
